import baseUrl from "../energyApiHost";
import dingoBaseUrl from "../dingoApiHost";
import { callApi } from "./util";
import moment from "moment";

const getStore = storeId => {
  const url = `${baseUrl}stores/${storeId}`;
  return callApi(url);
};

const getStores = searchTerm => {
  let url = `${baseUrl}stores`;

  if (searchTerm) {
    url += `?searchTerm=${searchTerm}`;
  }

  return callApi(url);
};

const getOpeningHours = (storeId, from, to) => {
  const fromDate = moment(from).format("YYYY-MM-DD");
  const toDate = moment(to).format("YYYY-MM-DD");

  const url = `${baseUrl}stores/${storeId}/opening-hours?from=${fromDate}&to=${toDate}`;
  return callApi(url);
};

const getDevices = (storeId, category, purpose, subpurpose) => {
  let url = `${baseUrl}stores/${storeId}/devices`;

  const parameters = [];

  if (category && category !== "undefined") {
    parameters.push(`submeter-category=${encodeURIComponent(category)}`);
  }
  if (purpose && purpose !== "undefined") {
    parameters.push(`submeter-purpose=${encodeURIComponent(purpose)}`);
  }
  if (subpurpose && subpurpose !== "undefined") {
    parameters.push(`submeter-sub-purpose=${encodeURIComponent(subpurpose)}`);
  }

  if (parameters.length > 0) {
    url += "?" + parameters.join("&");
  }

  return callApi(url);
};

const getLatestSensorDataForStore = storeId => {
  const url = `${dingoBaseUrl}stores/${storeId}/sensor-data/latest`;
  return callApi(url);
};

export default {
  getStore,
  getStores,
  getOpeningHours,
  getDevices,
  getLatestSensorDataForStore
};
